import React from "react";
import "@frameworks/shared-library/stylesheets/components/GenericStatus/GenericStatus.scss";
export var EGenericStatusType;
(function (EGenericStatusType) {
    EGenericStatusType["SUCCESS"] = "SUCCESS";
    EGenericStatusType["WARNING"] = "WARNING";
    EGenericStatusType["DANGER"] = "DANGER";
    EGenericStatusType["PENDING"] = "PENDING";
})(EGenericStatusType || (EGenericStatusType = {}));
var GenericStatus = function (props) {
    var _a;
    var generateClassName = function () {
        switch (props.statusType) {
            case EGenericStatusType.SUCCESS:
                return "success-status";
            case EGenericStatusType.DANGER:
                return "danger-status";
            case EGenericStatusType.WARNING:
                return "warning-status";
            case EGenericStatusType.PENDING:
                return "pending-status";
            default:
                return "pending-status";
        }
    };
    return (React.createElement("div", { className: "".concat((_a = props.parentClassName) !== null && _a !== void 0 ? _a : "", " primary-generic-status-container d-flex align-items-center gap-5px ").concat(generateClassName()) },
        (props === null || props === void 0 ? void 0 : props.customIcon) ? props.customIcon : React.createElement("i", { className: "edel-icon-round-circle" }),
        React.createElement("span", { className: "status-text" }, props.statusText)));
};
export default GenericStatus;
